import { processOssImage as _processOssImage } from "@xp-design/mobile/lib/utils/oss-process-image";
export const processOssImage = (url: string): string => {
    if (!url) return '';
    return _processOssImage(url);
}